import { useEffect, useRef, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { confirmAccount } from "../api/auth";
import { normalizeApiError } from "../utils/authValidation";

type Status = "loading" | "success" | "error";

export default function ConfirmAccountPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [status, setStatus] = useState<Status>(token ? "loading" : "error");
  const [message, setMessage] = useState(token ? "Подтверждаем аккаунт..." : "Ссылка подтверждения некорректна");
  const requestedRef = useRef(false);

  useEffect(() => {
    if (!token || requestedRef.current) return;
    requestedRef.current = true;

    confirmAccount(token)
      .then((response) => {
        setStatus("success");
        setMessage(response.message || "Аккаунт подтверждён. Теперь можно войти.");
      })
      .catch((error) => {
        setStatus("error");
        setMessage(normalizeApiError(error, "Не удалось подтвердить аккаунт"));
      });
  }, [token]);

  const isSuccess = status === "success";
  const isLoading = status === "loading";
  const Icon = isLoading ? Loader2 : isSuccess ? CheckCircle2 : XCircle;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white px-6 py-10 text-slate-900">
      <main className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-xl items-center justify-center">
        <section className="w-full rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-[0_20px_50px_rgba(15,23,42,0.08)]">
          <div
            className={`mx-auto inline-flex h-14 w-14 items-center justify-center rounded-2xl ${
              isLoading
                ? "bg-indigo-50 text-indigo-600"
                : isSuccess
                  ? "bg-emerald-50 text-emerald-600"
                  : "bg-rose-50 text-rose-600"
            }`}
          >
            <Icon size={28} className={isLoading ? "animate-spin" : ""} />
          </div>
          <h1 className="mt-5 text-2xl font-bold text-slate-900">Подтверждение аккаунта</h1>
          <p className="mt-3 text-sm leading-6 text-slate-500">{message}</p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Link
              to="/auth/login"
              className="inline-flex items-center justify-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Ко входу
            </Link>
            {!isSuccess && (
              <Link
                to="/auth/register"
                className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Регистрация
              </Link>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
